import { Component, Inject, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { GrievanceCommentComponent } from '../grievance-comment/grievance-comment.component';
import { Location } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-grievance-comment-form',
  templateUrl: './grievance-comment-form.component.html',
  styleUrls: ['./grievance-comment-form.component.scss']
})
export class GrievanceCommentFormComponent implements OnInit {
  dialogRef: MatDialogRef<any>;
  grievanceCommentForm: FormGroup;
  submitpayload: any;
  isOtherChecked = false;
  selectedOption: string = '';
  Course: any;
  CoCode; any;
  address: any;
  city: any;
  session: any;
  state: any;
  pincode: any;
  departmentList: any;
  filterdepartmentList: any;
  statusList: any;
  filterstatusList: any;
  complaintList: any;
  data: any;
  GrievanceID: 0;
  StuloginID: 0;
  DepartmentID: 0;
  GrievanceTitle: any;
  GrievanceDescription: any;
  PreviousAttempt: any;
  PreviousAttemptDetail: any;
  StatusCode: any;
  actionList: any;
  actionCommentList: any;
  grivenceData;
  commentList: any;
  StuFullName: any;
  grievancestatus = false;
  // GrievanceClose: number;
  showUpdateButton: boolean = false;
  PreFix: any;
  formattedPrn: string;
  constructor(public umsService: UmsService, private spinner: NgxSpinnerService,
    private fb: FormBuilder, private modalPopupService: ModalpopService, private dialog: MatDialog,
    private route: ActivatedRoute, private location: Location, public router: Router,
    private datePipe: DatePipe,
  ) {
  }
  InstuName
  RgNo
  StateCodeListC
  FirstName: string
  MiddleName: string
  LastName: string
  Number: number
  showOtherTextArea = false;
  grievanceFormArray;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  commentFormArray;
  // convertUTCToIST(dateString: string): string {
  //   const utcDate = new Date(dateString); // Convert string to Date object
  //   const istDate = new Date(utcDate.getTime() - (330 * 60 * 1000)); // IST is UTC + 5:30
  //   return this.datePipe.transform(istDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  // }
  ngOnInit(): void {
    const state = history.state;
    this.grivenceData = state.data;
    if (!this.grivenceData) {
      this.grivenceData = JSON.parse(localStorage.getItem('grivenceData') || '{}');

    }
    this.prepopulation(this.grivenceData);
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.loadsettingspage();
    this.loadsettingspage1();
    this.getSecretData();
    this.getActionCommentData();
    this.stuAddDetails();
    this.getDepartment();
    this.fetchStatus();
    this.getCourse();
    this.getComplaintData();
    this.RgNo = this.grivenceData.LoginId;
    this.transPRN(this.RgNo)
    this.grievanceCommentForm = this.fb.group({
      GrievanceID: new FormControl(this.grivenceData.GrievanceID),
      StuloginID: new FormControl(this.grivenceData.StuloginID, [Validators.required]),
      GrievanceTitle: new FormControl(this.grivenceData.GrievanceTitle, [Validators.required]),
      GrievanceDescription: new FormControl(this.grivenceData.GrievanceDescription, [Validators.required]),
      StatusCode: new FormControl(this.grivenceData.StatusCode, [Validators.required]),
      DepartmentID: new FormControl((this.grivenceData.DepartmentID), [Validators.required]),
      PreviousAttempt: new FormControl((this.grivenceData.PreviousAttempt), [Validators.required]),
      PreviousAttemptDetail: new FormControl(this.grivenceData.PreviousAttemptDetail),
    });

  }
  transPRN(RgNo) {
    let RgNo1 = 99999;
    this.formattedPrn = sessionStorage.getItem('LoginName')
  }

  getCourse() {
    let payload = {};
    payload['CoCode'] = this.grivenceData.CoCode
    this.umsService.fetchCourseType(payload).subscribe((res) => {
      this.PreFix = res.data[0].CoRgPrfx
    })

  }

  getSecretData() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.spinner.hide();
      this.InstuName = res.projectPharam['InstituteName']
      this.session = res.projectPharam['SnName']
    })
  }

  stuAddDetails() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.grivenceData.StuloginID;
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.address = res.data[0]['StuAddrC'];
        this.city = res.data[0]['StuCityC'];
        this.pincode = res.data[0]['StuPinC'];
        if (res.data.length > 0) {
          this.fetchStateC(res.data[0].StuCountryC, res.data[0].StuStateC);
        }
      } else {
        this.spinner.hide();
      }
    });
  }

  fetchStateC(CountryCode, StateCode) {
    // this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        const stateData = res.data.find(state => state.StateCode === StateCode);
        if (stateData) {
          this.state = stateData.StateName;
        }
      }
    });
  }

  getDepartment() {
    const payload = {};
    this.umsService.getDepartment(payload).subscribe((res) => {
      if (res.status) {
        this.departmentList = res.data;
        this.filterdepartmentList = this.departmentList.slice();
      } else {
      }
    });
  }

  onDepartmentChange(value: string): void {
    this.showOtherTextArea = value === 'OTH';
  }

  UpdateComplaint() {

    this.spinner.show();
    this.submitpayload = this.grievanceCommentForm.value;
    let payload = {}
    payload['GrievanceID'] = this.submitpayload.GrievanceID
    payload['GrievanceTitle'] = this.submitpayload.GrievanceTitle
    payload['GrievanceDescription'] = this.submitpayload.GrievanceDescription
    payload['DepartmentID'] = this.submitpayload.DepartmentID
    payload['PreviousAttempt'] = this.submitpayload.PreviousAttempt
    payload['PreviousAttemptDetail'] = this.submitpayload.PreviousAttemptDetail
    payload['StatusCode'] = this.StatusCode
    payload['StuloginID'] = this.grivenceData.LoginId
    // payload['GrievanceClose'] = this.GrievanceClose
    this.umsService.updateComplaint(payload).subscribe(res => {
      this.grievancestatus = true;
      this.spinner.hide();

      if (res.status) {
        let data = {}
        if (this.StatusCode === 'C') {
          data['message'] = "Grievance closed successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.goBack();
          });
        } else {
          data['message'] = "Updated Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.goBack();
          });
        }
      }
      else {
      }

    },
    );
  }

  prepopulation(data) {
    this.grievanceCommentForm = this.fb.group({
      GrievanceID: new FormControl(data.GrievanceID),
      StuloginID: new FormControl(data.StuloginID, [Validators.required]),
      GrievanceTitle: new FormControl(data.GrievanceTitle, [Validators.required]),
      GrievanceDescription: new FormControl(data.GrievanceDescription, [Validators.required]),
      StatusCode: new FormControl(data.StatusCode, [Validators.required]),
      DepartmentID: new FormControl(data.DepartmentID, [Validators.required]),
      PreviousAttempt: new FormControl(data.PreviousAttempt, [Validators.required]),
      PreviousAttemptDetail: new FormControl(data.PreviousAttemptDetail, [Validators.required]),
      // GrievanceClose: new FormControl(data.GrievanceClose, [Validators.required]),
    });
    if (data.StatusCode === 'C') {
      this.grievancestatus = true;

    }

  }

  onOptionChange(event: Event): void {
    const selectedOption = (event.target as HTMLInputElement).value;

    if (!selectedOption) {
      // Clear the details field if 'no' is selected
      this.grievanceCommentForm.get('PreviousAttemptDetail').setValue('');
    }
  }

  fetchStatus() {
    const payload = {};
    payload['CdType'] = 'GS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.statusList = res.data;
        this.filterstatusList = this.statusList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  getComplaintData() {
    this.spinner.show();
    const payload = {};
    payload['StuloginID'] = sessionStorage.getItem('loginId');
    this.umsService.getComplaint(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.complaintList = res.data;
      } else {
      }
    },
      //  (ERROR: HttpErrorResponse) => {
      // }
    );
  }



  getActionData() {
    const payload = {};
    payload['GrievanceID'] = this.grivenceData.GrievanceID
    payload['ActionID'] = ''
    this.umsService.getAction(payload).subscribe(res => {
      if (res.status) {
        this.actionList = res.data;
      } else {
      }
    },
    );
  }

  getCommentData() {
    const payload = {};
    payload['GrievanceID'] = this.grivenceData.GrievanceID
    payload['CommentID'] = ''
    this.umsService.getComment(payload).subscribe(res => {
      if (res.status) {
        this.commentList = res.data;
      } else {
      }
    },
    );
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(GrievanceCommentComponent, {
      width: '700px',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getActionCommentData();
    });
  }
  redirect(to): void {
    this.router.navigate([to]);
  }
  Back() {
    // this.router.navigate(['/Complaint']);
    this.goBack();
  }
  goBack(): void {
    this.location.back();
  }
  Close() {
    this.showUpdateButton = true;
    const data = {};
    data['message'] = 'Are you sure you want to close this grievance?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.StatusCode = 'C'
      } else if (result === 'no') {
        this.StatusCode = 'O'
      }
    });

  }

  status(selectedValue: string) {
    if (selectedValue === '1') {
      this.Close();
    }
  }

  getActionCommentData() {
    const payload = {};
    payload['GrievanceID'] = this.grivenceData.GrievanceID
    // payload['ActionID'] = ''
    this.umsService.getActionComment(payload).subscribe(res => {
      if (res.status) {
        this.actionCommentList = res.data;
      } else {
      }
    },
    );
  }

  loadsettingspage() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'Grievance';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.grievanceCommentForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            } else {
              this.grievanceCommentForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            if (element.FormPattern == '') {
              this.grievanceCommentForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.grievanceCommentForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }
          }
        }
      });
      this.grievanceFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString); // Convert string to Date object
    // Directly use the date pipe with 'Asia/Kolkata' time zone
    return this.datePipe.transform(utcDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  }
  loadsettingspage1() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'Grievance';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          // if (element.FormRequired) {
          // if (element.FormPattern == '') {
          this.grievanceCommentForm.addControl(element.FormControlName, new FormControl(''));
        } else {
          this.grievanceCommentForm.addControl(element.FormControlName, new FormControl(''));
        }
        // } else {
        //   if (element.FormPattern == '') {
        //     this.commentForm.addControl(element.FormControlName, new FormControl(''));
        //   } else {
        //     this.commentForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
        //   }
        // }
        // }
      });
      this.commentFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
}

